import(/* webpackMode: "eager" */ "/vercel/path0/app/auctions/page.tsx");
